/* eslint-disable camelcase */
import isApiError from "@insite/client-framework/Common/isApiError";
import { createHandlerChainRunner, HasOnError, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import { updateAccessorial, UpdateAccessorialApiParameters } from "@tKgpco/Services/AccessorialsService";
import { CustomApiHandler } from "@tKgpco/Store/CustomHandlerCreator";
import { Accessorials } from "@tKgpco/Store/Data/Accessorials/AccessorialsState";

type Parameters = UpdateAccessorialApiParameters & HasOnSuccess & HasOnError;
type HandlerType = CustomApiHandler<Parameters, Accessorials>;

export const PopulateApiParameters: HandlerType = props => {
    const { Id, TI_Code, TI_Description, Enabled, Master, Name, Type, CarrierNoteOnly, CarrierNotes } = props.parameter;
    props.apiParameter = {
        Id,
        TI_Code,
        TI_Description,
        Enabled,
        Master,
        Name,
        Type,
        CarrierNoteOnly,
        CarrierNotes,
    };
};

export const UpdateAccessorial: HandlerType = async props => {
    try {
        await updateAccessorial(props.apiParameter);
    } catch (error) {
        if (isApiError(error) && (error.status === 400 || error.status === 409)) {
            props.parameter.onError?.(error.errorJson.message);
            return false;
        }
        throw error;
    }
};

export const ExecuteOnSuccess: HandlerType = props => {
    props.parameter.onSuccess?.();
};

export const chain = [PopulateApiParameters, UpdateAccessorial, ExecuteOnSuccess];

const editAccessorial = createHandlerChainRunner(chain, "EditAccessorial");
export default editAccessorial;
